import * as React from 'react';
import { InfoOutline, CaptionTypography } from '../../../atoms';
import type { ComplexTreeEmptyStateProps } from '../types';

export const ComplexTreeEmptyState: React.FC<ComplexTreeEmptyStateProps> = ({ icon, message, ariaLabel }) => (
	<div
		className="flex h-full flex-col items-center justify-center px-[0.5rem] py-[1rem] text-center"
		data-testid="complex-tree-empty-state"
		role="status"
		aria-label={ariaLabel}
	>
		<div className="mb-[0.6rem]" aria-hidden="true">{icon ?? <InfoOutline className="text-secondary" />}</div>
		<CaptionTypography className="text-secondary">{message ?? ''}</CaptionTypography>
	</div>
);
